import { NavigateFunction } from "react-router-dom";

export const stepHistoryHelper = {
  regularStepsHistory: [
    "/step-1",
    "/step-2",
    "/step-3",
    "/step-4",
    "/step-5",
    "/step-6",
    "/step-7",
  ],
  airBnbStepsHistory: ["/step-1", "/step-3", "/step-5", "/step-7"],
  shuttleStepsHistory: [
    "/step-1",
    "/step-2",
    "/step-3",
    "/step-5",
    "/step-6",
    "/step-7",
  ],

  next: function (
    navigate: NavigateFunction,
    isCustomDestination: boolean,
    location: string,
    isShuttle: boolean | undefined
  ) {
    isShuttle = isShuttle ?? false;

    const stepArray = isCustomDestination
      ? this.airBnbStepsHistory
      : isShuttle
        ? this.shuttleStepsHistory
        : this.regularStepsHistory;

    const nextStepIndex = stepArray.indexOf(location) + 1;

    if (stepArray[nextStepIndex]) {
      navigate(`${stepArray[nextStepIndex]}`);
    }
  },

  prev: function (
    navigate: NavigateFunction,
    isCustomDestination: boolean,
    location: string,
    isShuttle: boolean | undefined
  ) {
    isShuttle = isShuttle ?? false;

    const stepArray = isCustomDestination
      ? this.airBnbStepsHistory
      : isShuttle
        ? this.shuttleStepsHistory
        : this.regularStepsHistory;

    const nextStepIndex = stepArray.indexOf(location) - 1;

    if (stepArray[nextStepIndex]) {
      navigate(`${stepArray[nextStepIndex]}`);
    }
  },
};
